import logo from "./logo.svg";
import logoPNG from "./logo_png.png";
import loader from "./loader.svg";
import sound from "./pop-up-on.mp3";
export const IMAGES =  {
    logo,
    logoPNG,
    loader,
    sound
}